
import Shimmer from "../ui/shimmer";

export const WelcomeHeaderLoading = () => (
  <div className="p-4 pt-16 sm:p-6 sm:pt-12 space-y-2 sm:space-y-4 text-center">
    <Shimmer className="h-8 w-64 mx-auto" />
    <Shimmer className="h-4 w-48 mx-auto" />
  </div>
);

export const StatsCarouselLoading = () => (
  <div className="px-6 sm:px-8 py-4 sm:py-6">
    <div className="mx-auto max-w-4xl">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3].map((i) => (
          <Shimmer key={i} className="h-32 w-full rounded-lg" />
        ))}
      </div>
    </div>
  </div>
);

export const NewsFeedLoading = () => (
  <section className="mt-8 px-6">
    <Shimmer className="h-8 w-48 mb-6" />
    <div className="space-y-4">
      {[1, 2, 3].map((i) => (
        <Shimmer key={i} className="h-24 w-full rounded-lg" />
      ))}
    </div>
  </section>
);
